/* eslint-disable radix */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable import/no-extraneous-dependencies */
import { ToastContainer } from 'react-toastify'
import { useState } from 'react'
import dayjs from 'dayjs'
import { ChevronRight } from '../../assets/icons/chevron right'
import { HeaderCard } from '../../components/HeaderCard/HeaderCard'
import { ChevronRightStyle } from '../../components/HeaderCard/HeaderCard.style'
import { Loading } from '../../components/Loading/Loading'
import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
import { Tour } from '../../components/Tour'
import TourPredicoes from '../../utils/JoyRide/tourPredicoes'
import { dateToBr } from '../../utils/transformDate'
import 'dayjs/locale/pt-br'

import {
  Div,
  DivCards,
  DivInput,
  Wrapper,
  Table,
  Container,
  ContainerSearch,
  Calendars,
  Filters,
  TypesFilter,
  FilterClient,
  FilterSalesPeople,
  OptionActive,
  Option,
  Filtro,
  DatePickerStyle,
  FiltersCalendar,
  TypesFilterCalendar,
  FilterCompanie,
  FilterStatus,
  FilterProduct,
  FilterUsuario,
  Export,
  Filtros,
} from './HistoricoBaixa.style'
import { useHistoricoBaixa } from './useHistoricoBaixa'
import { Pagination } from '../../components/Pagination/Pagination'
import { ArrowDown } from '../../assets/icons/arrowDown'
import { Button } from '../../components/SideBar/Menu.style'
import { UserPositioning } from '../../assets/icons/user-positioning'
import SelectCompanie from '../../components/MultipleSelect'
import { UserBlack } from '../../assets/icons/userBlack'
import DatesPicker from '../../components/Calendar/datePicker'
import Tooltips from '../../components/Tooltip'
import { CityBlack } from '../../assets/icons/cityBlack'
import Status from '../../assets/icons/status'
import { AdProduct } from '../../assets/icons/ad-product'
import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { SpanFilter, Ul } from '../../layouts/LayoutTable/LayoutTable'
import Clear from '../../assets/icons/clear'

export function HistoricoBaixa() {
  const {
    historicoDeBaixa,
    isLoading,
    goToPage,
    setCurrentPage,
    currentPage,
    setCalendarFim,
    setCalendarInicio,
    setClient,
    setSalesPeople,
    handleShowFilterClient,
    handleShowFilterSalesPeople,
    showClient,
    showSalesPeople,
    handleKeyClosed,
    selectedOptionsSalesPeople,
    selectedOptionsClient,
    selectedOptionsEmpresas,
    selectedOptionsProdutos,
    handleShowFilterCompanie,
    showCompanies,
    setValueCompanieId,
    showStatus,
    handleShowStatus,
    showProducts,
    setValueProductId,
    handleShowProduto,
    showUsuario,
    handleShowUsuario,
    setUsuarioEmail,
    statusChecked,
    handleCheckboxChange,
    statusCheckedTodos,
    setStatusCheckedFiltro,
    dataHoje,
    valueClient,
    setValueClient,
    valueSalesPeople,
    setValueSalesPeople,
    valueCompanie,
    setValueCompanie,
    valueProduct,
    setValueProduct,
    valueUsuario,
    setValueUsuario,
    arrayClientes,
    arrayVendedores,
    arrayEmpresas,
    arrayProdutos,
    arrayUsuarios,
    productArray,
    companieArray,
    salesPeopleArray,
    clientArray,
    usuarioEmailArray,

    vendedores,
    clients,
    companies,
    produto,
    usuarios,
    selectedOptionsUsuario,

    handleFiltroCliente,
    handleFiltroVendedor,
    handleFiltroEmpresa,
    handleFiltroProduto,
    handleFiltroUsuario,
    handleLimparFiltros,

    handleClienteFiltrado,
    handleVendedorFiltrado,
    handleEmpresaFiltrada,
    handleProdutoFiltrado,
    handleUsuarioFiltrado,
  } = useHistoricoBaixa()

  const data = localStorage.getItem('dataInicio')
  const dataSelecionadaPredicao = data ? JSON.parse(data) : null
  // `dataInicio` é chave GLOBAL do localStorage, gravada pela tela de Predições. Sem ela,
  // `null.split` derrubava esta tela EM BRANCO (o projeto não tem ErrorBoundary) — a DT-37,
  // já corrigida em `usePredictionDetails`/`ClientDetails` e esquecida aqui. Passou a
  // importar porque a rota deixou de ser só do coordenador: vendedor e assistente chegam
  // por favorito e por aba nova, em carga fria, sem nunca ter aberto /predicoes.
  const dataFormatada = dataSelecionadaPredicao
    ? dataSelecionadaPredicao.split('/')
    : []
  const dataValida = dataSelecionadaPredicao
    ? `${dataFormatada[1]}/${dataFormatada[0]}/${dataFormatada[2]}`
    : ''
  const formatData = dataValida ? dayjs(dataValida) : dayjs()
  const dataInicio = formatData.format('DD/MM/YYYY')
  const lastDayOfMonth = dayjs().endOf('month')
  const dataFim = lastDayOfMonth.format('DD/MM/YYYY')

  const [dateEnd, setDateEnd] = useState(dataFim)
  const [dateStart, setDateStart] = useState(dataInicio)

  const handleFiltroDataInicio = (event: string) => {
    localStorage.setItem('dataInicio', JSON.stringify(event))
    setDateStart(event)
  }

  return (
    <>
      <ToastContainer theme="dark" />
      <DivTitle id="saudacaoPredicao" color="black" size={22}>
        <ContainerTitle>
          Histórico de baixa
          <ContainerTitle>
            <Tooltips icon={<Tour steps={TourPredicoes} />} text="Tour" />
          </ContainerTitle>
        </ContainerTitle>
      </DivTitle>
      <ContainerSearch>
        <Filtros>
          <DivInput>
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterClient}
              >
                <UserPositioning /> Cliente <ArrowDown />
              </Filters>
            </TypesFilter>
            {showClient && (
              <FilterClient onKeyDown={handleKeyClosed}>
                <Filtro>
                  {isLoading ? (
                    <Loading contrast={false} />
                  ) : (
                    <SelectCompanie
                      value={valueClient}
                      handle={handleFiltroCliente}
                      array={arrayClientes ? clients : []}
                    />
                  )}
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      handleClienteFiltrado(clientArray)
                      handleShowFilterClient()
                    }}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterClient>
            )}
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterSalesPeople}
              >
                <UserBlack /> Vendedor <ArrowDown />
              </Filters>
            </TypesFilter>
            {showSalesPeople && (
              <FilterSalesPeople onKeyDown={handleKeyClosed}>
                <Filtro>
                  {isLoading ? (
                    <Loading contrast={false} />
                  ) : (
                    <SelectCompanie
                      value={valueSalesPeople}
                      handle={handleFiltroVendedor}
                      array={arrayVendedores ? vendedores : []}
                    />
                  )}
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      handleShowFilterSalesPeople()
                      handleVendedorFiltrado(salesPeopleArray)
                    }}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterSalesPeople>
            )}
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterCompanie}
              >
                <CityBlack /> Empresa <ArrowDown />
              </Filters>
            </TypesFilter>
            {showCompanies && (
              <FilterCompanie onKeyDown={handleKeyClosed}>
                <Filtro>
                  {isLoading ? (
                    <Loading contrast={false} />
                  ) : (
                    <SelectCompanie
                      value={valueCompanie}
                      handle={handleFiltroEmpresa}
                      array={arrayEmpresas ? companies : []}
                    />
                  )}
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      handleShowFilterCompanie()
                      handleEmpresaFiltrada(companieArray)
                    }}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterCompanie>
            )}
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowStatus}
              >
                <Status /> Status <ArrowDown />
              </Filters>
            </TypesFilter>
            {showStatus && (
              <FilterStatus onKeyDown={handleKeyClosed}>
                <SpanFilter>Filtrar por: </SpanFilter>

                <div>
                  <Ul>
                    <ItemFilter
                      top="2px"
                      checked={!statusCheckedTodos.includes('TODOS')}
                      onChange={() => {
                        handleCheckboxChange('TODOS')
                      }}
                      text="Todos"
                      id="all"
                    />
                    <ItemFilter
                      top="2px"
                      checked={statusChecked.includes('EM_ALTA')}
                      onChange={() => {
                        handleCheckboxChange('EM_ALTA')
                      }}
                      text="Em alta"
                      id="onHigh"
                    />
                    <ItemFilter
                      top="2px"
                      checked={statusChecked.includes('EM_BAIXA')}
                      onChange={() => {
                        handleCheckboxChange('EM_BAIXA')
                      }}
                      text="Em baixa"
                      id="low"
                    />
                    <ItemFilter
                      top="2px"
                      checked={statusChecked.includes('NEUTRO')}
                      onChange={() => {
                        handleCheckboxChange('NEUTRO')
                      }}
                      text="Neutro"
                      id="neutro"
                    />
                  </Ul>
                </div>
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    setStatusCheckedFiltro(statusChecked)
                    handleShowStatus()
                  }}
                >
                  Aplicar
                </Button>
              </FilterStatus>
            )}
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowProduto}
              >
                <AdProduct /> Produto <ArrowDown />
              </Filters>
            </TypesFilter>
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowUsuario}
              >
                <UserBlack /> Usuário <ArrowDown />
              </Filters>
            </TypesFilter>
          </DivInput>
          <TypesFilter>
            <Export
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={() => {
                handleLimparFiltros()
                handleCheckboxChange('TODOS')
                setCalendarInicio(dataHoje)
                setValueClient([])
                setValueSalesPeople([])
                setValueCompanie([])
                setValueProduct([])
                setValueUsuario([])
                setClient([])
                setSalesPeople([])
                setValueProductId([])
                setValueCompanieId([])
                setUsuarioEmail([])
                setStatusCheckedFiltro([])
              }}
            >
              <Clear />
              Limpar
            </Export>
          </TypesFilter>
        </Filtros>
        {showProducts && (
          <FilterProduct onKeyDown={handleKeyClosed}>
            <Filtro>
              {isLoading ? (
                <Loading contrast={false} />
              ) : (
                <SelectCompanie
                  value={valueProduct}
                  handle={handleFiltroProduto}
                  array={arrayProdutos ? produto : []}
                />
              )}
              <Button
                buttonType="SMALL"
                type="button"
                onClick={() => {
                  handleShowProduto()
                  handleProdutoFiltrado(productArray)
                }}
              >
                Aplicar
              </Button>
            </Filtro>
          </FilterProduct>
        )}
        {showUsuario && (
          <FilterUsuario onKeyDown={handleKeyClosed}>
            <Filtro>
              {isLoading ? (
                <Loading contrast={false} />
              ) : (
                <SelectCompanie
                  value={valueUsuario}
                  handle={handleFiltroUsuario}
                  array={arrayUsuarios ? usuarios : []}
                />
              )}
              <Button
                buttonType="SMALL"
                type="button"
                onClick={() => {
                  handleShowUsuario()
                  handleUsuarioFiltrado(usuarioEmailArray)
                }}
              >
                Aplicar
              </Button>
            </Filtro>
          </FilterUsuario>
        )}
        <TypesFilterCalendar>
          <FiltersCalendar onKeyDown={handleKeyClosed}>
            <Calendars>
              <DatePickerStyle>
                Data início:
                <DatesPicker
                  handleDataSelecionada={handleFiltroDataInicio}
                  size="130px"
                  dayjs={formatData}
                />
              </DatePickerStyle>
              <DatePickerStyle>
                Data fim:
                <DatesPicker
                  handleDataSelecionada={setDateEnd}
                  size="130px"
                  dayjs={lastDayOfMonth}
                />
              </DatePickerStyle>

              <Button
                buttonType="SMALL"
                type="button"
                onClick={() => {
                  setCalendarInicio(dateStart)
                  setCalendarFim(dateEnd)
                }}
              >
                Aplicar
              </Button>
            </Calendars>
          </FiltersCalendar>
        </TypesFilterCalendar>
      </ContainerSearch>

      <OptionActive>
        {selectedOptionsClient &&
          selectedOptionsClient.map(option => (
            <Option key={option}>
              <strong>Cliente: </strong>
              {option}
            </Option>
          ))}
        {selectedOptionsSalesPeople &&
          selectedOptionsSalesPeople.map(option => (
            <Option key={option}>
              <strong>Vendedor: </strong>
              {option}
            </Option>
          ))}
        {statusChecked &&
          statusChecked.map(option => (
            <Option key={option}>
              <strong>Status: </strong>
              {option}
            </Option>
          ))}

        {selectedOptionsEmpresas &&
          selectedOptionsEmpresas.map(option => (
            <Option key={option}>
              <strong>Empresa: </strong>
              {option}
            </Option>
          ))}
        {selectedOptionsProdutos &&
          selectedOptionsProdutos.map(option => (
            <Option key={option}>
              <strong>Produto: </strong>
              {option}
            </Option>
          ))}
        {selectedOptionsUsuario &&
          selectedOptionsUsuario.map(option => (
            <Option key={option}>
              <strong>Usuário: </strong>
              {option}
            </Option>
          ))}
      </OptionActive>
      {isLoading ? (
        <Loading contrast={false} />
      ) : (
        <>
          <DivCards key={JSON.stringify(historicoDeBaixa)}>
            {historicoDeBaixa.content &&
              historicoDeBaixa.content.map(item => (
                <Wrapper
                  onClick={() => goToPage(item.id)}
                  id="cardPredicaoProduto"
                  key={item.id}
                >
                  <Div id="cardPredicaoCliente">
                    <HeaderCard
                      status={item.classificacao}
                      title={item.nome}
                      percentual={String(item.percentual).replace('.', ',')}
                    />
                    <ChevronRightStyle>
                      <ChevronRight />
                    </ChevronRightStyle>
                  </Div>
                  <Container>
                    <Table>
                      <thead>
                        <tr>
                          <th>Produto</th>
                          <th>Data da baixa</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.produtos.map(produtos => (
                          <tr key={produtos.id}>
                            <td>{produtos.nome}</td>
                            <td>{dateToBr(produtos.baixa)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Container>
                </Wrapper>
              ))}
          </DivCards>
          <Pagination
            pageNumber={currentPage}
            pageSize={historicoDeBaixa.totalElements}
            offSet={historicoDeBaixa.size}
            onClick={page => setCurrentPage(page)}
          />
        </>
      )}
    </>
  )
}
